import { SupplierCompanyItem } from "../suppliers";
import { UserItem } from "../users";

export const TASK_TRIGGER_PERIODICALLY = "TRIGGER_PERIODICALLY" as const;
export const TASK_TRIGGER_ON_EVENT = "TRIGGER_ON_EVENT" as const;

export type TaskTrigger =
  | typeof TASK_TRIGGER_PERIODICALLY
  | typeof TASK_TRIGGER_ON_EVENT;

export interface MachineRelation {
  id: number;
  machine: TaskHubMachine;
}

export interface TaskHubMachine {
  id: number;
  name: string;
  process_template: number;
}

export interface ProductCardRelation {
  id: number;
  product_card: OrderProductCard;
}

export interface OrderProductCard {
  id: number;
  name: string;
  is_archived: boolean;
  process_steps: number[];
  companytoproductcards: any[];
}

export interface TaskHubItem {
  id: number;
  icon: string | null;
  name: string;
  trigger?: TaskTrigger | null;
  periodicity: "daily" | "weekly" | "monthly" | "yearly" | string;
  periodicity_multiple: number | null;
  is_recurrent: boolean;
  priority: string;
  start_periodicity: string;
  enabled: boolean;
  users: {
    id: number;
    user: UserItem;
  }[];
  user__full_name: string;
  files: { id: number; file: string; task: number }[];

  machines: MachineRelation[];
  product_cards: ProductCardRelation[];
  description: string | null;
  companies: {
    id: number;
    company: SupplierCompanyItem;
  }[];
}

export interface CreateTaskHub {
  id?: number;
  icon: string;
  name: string;
  periodicity: "daily" | "weekly" | "monthly" | "yearly" | string;
  day_of_week?: string;
  day_of_month?: number | null;
  day_of_year?: number | null;
  start_periodicity: string;
  machines: number[];
  product_card: number[];
  user__full_name: string;
}

export interface PaginatedTaskHubResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: TaskHubItem[];
}

export interface getTaskHubParams {
  offset: number;
  limit: number;
  ordering?: string;
  name__icontains?: string;
  periodicity?: string;
  day_of_week?: string;
  day_of_month?: string;
  priority__gte?: string | number;
  priority__lte?: string | number;
  day_of_year?: string;
  enabled?: boolean;
  start_periodicity__gte?: string;
  start_periodicity__lte?: string;
  user__full_name?: string;
  expand?: string;
  users__user__in?: number[];
  trigger__in?: TaskTrigger[];
}

// Stand Alone
export interface StandaloneTask {
  id: number;
  name: string;
  influxdb_server: number;
  measurement: string;
  field: string;
  enabled: boolean;
  priority: number;
  lookback_days: number;
  target_value: number;
  min_soft: number;
  max_soft: number;
  min_hard: number;
  max_hard: number;
}

export interface TaskStandAloneAlarm {
  id: number;
  task_standalone: StandaloneTask;
  timestamp_created: string;
  timestamp_updated: string;
  is_min_soft: boolean;
  is_max_soft: boolean;
  is_min_hard: boolean;
  is_max_hard: boolean;
  max_value: number;
  min_value: number;
  timestamp_triggered: string;
  is_active: boolean;
  comments: string;
}

export interface StandaloneTaskResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: StandaloneTask[];
}

export interface CreateStandaloneTask {
  name: string;
  influxdb_server: number;
  measurement: string;
  field: string;
  enabled: boolean;
  priority: number;
  lookback_days: number;
  target_value: number;
  min_soft: number;
  max_soft: number;
  min_hard: number;
  max_hard: number;
}

export interface GetStandaloneTaskByIdParams {
  id: number;
  expand?: string;
  fields?: string;
  omit?: string;
  format?: "json" | "xml";
}

export type UpdateStandaloneTask = Partial<CreateStandaloneTask> & {
  id: number;
};

export type PatchStandaloneTask = Partial<CreateStandaloneTask> & {
  id: number;
};
